import { HStack, Text } from '@chakra-ui/react';

import { Switch, SwitchProps } from '../../lib/chakraUi/components';
import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';

export const YesNoSwitch: FormFieldControlledComponent<string, SwitchProps> = ({
  ...props
}: FormFieldControlledComponentProps<string, SwitchProps>) => (
  <HStack gap={4}>
    <Text>No</Text>
    <Switch {...props} />
    <Text>Yes</Text>
  </HStack>
);

YesNoSwitch.controlled = true;
YesNoSwitch.displayName = 'YesNoSwitch';
